import HelpScout from './HelpScout'

export default new HelpScout()
export {
  Company,
  Context,
  Conversation,
  Customer,
  Mailbox,
  MessageType,
  NotificationType,
  NotificationOptions,
  ConfirmNotificationOptions,
  PhoneType,
  CustomerProperty,
  CustomerPropertyType,
  SocialProfileType,
  Status,
  User,
} from './types'

export { MESSAGE_TYPES, NOTIFICATION_TYPES, STATUSES } from './constants'

export { isAllowedOrigin } from './utils'

export { commsHandler } from './handlers'
